import React from 'react';
import { PieChart } from 'lucide-react';
import ModulePageLayout, { Section, FeatureGrid } from '../../components/ModulePageLayout';
import { getModule } from '../../data/modules';

export default function FamePage() {
  const module = getModule('fame')!;
  return (
    <ModulePageLayout module={module} Icon={PieChart}>
      <Section title="Institutional Assets, Fractional Access">
        <p className="text-gray-700 leading-relaxed">
          FAME — the Fractional Asset Management Exchange — tokenizes real-world assets into ownership shares
          small investors can actually afford. Despite the name, it covers more than real estate: intellectual
          property, entertainment projects, and collectibles all sit in the same registry.
        </p>
      </Section>

      <Section title="Every Asset Carries Real Detail">
        <FeatureGrid
          items={[
            { title: 'SPV Structure', body: 'Each tokenized asset sits inside its own Special Purpose Vehicle, isolating legal liability and meeting regulatory requirements.' },
            { title: 'Gold Collateral Ratio', body: 'Assets carry a collateral ratio tying part of their value back to the Aureus Protocol\'s gold reserves.' },
            { title: 'Secondary Market', body: 'List your fractions for sale; buyers place market or limit orders that move from open to filled.' },
            { title: 'Dividends', body: 'Asset operators distribute proportional dividends to fractional owners, with optional auto-reinvestment.' },
          ]}
        />
      </Section>

      <Section title="Invest Together, or Visit in AR">
        <p className="text-gray-700 leading-relaxed">
          Group Investment Pools let users combine capital to access assets that would be out of reach
          individually, with shared governance over asset selection and exit strategy. Assets flagged for
          augmented reality let you visualize a property, collectible, or development through your phone
          camera before you invest.
        </p>
      </Section>
    </ModulePageLayout>
  );
}
